import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

// Shows "Nouvelle version disponible" when a new service worker is waiting; refresh happens only on click
export const UpdateBanner = () => {
  const [registration, setRegistration] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const onUpdate = (e) => { setRegistration(e.detail); setDismissed(false); };
    window.addEventListener('bourbon:sw-update', onUpdate);
    return () => window.removeEventListener('bourbon:sw-update', onUpdate);
  }, []);

  useEffect(() => {
    if (!updating || !('serviceWorker' in navigator)) return;
    const onChange = () => window.location.reload();
    navigator.serviceWorker.addEventListener('controllerchange', onChange);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', onChange);
  }, [updating]);

  if (!registration || dismissed) return null;

  const refresh = () => {
    setUpdating(true);
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setTimeout(() => window.location.reload(), 3000);
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      className="fixed bottom-20 sm:bottom-6 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-full border border-border bg-card/95 backdrop-blur px-4 py-2.5 shadow-xl animate-in slide-in-from-bottom-4"
      role="status"
      data-testid="update-banner"
    >
      <span className="text-sm font-medium">Nouvelle version disponible</span>
      <button
        type="button"
        onClick={refresh}
        disabled={updating}
        className="inline-flex items-center gap-1.5 rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:brightness-110 disabled:opacity-60"
        data-testid="update-banner-refresh-btn"
      >
        <RefreshCw className={`h-3.5 w-3.5 ${updating ? 'animate-spin' : ''}`} />
        Actualiser
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="text-muted-foreground hover:text-foreground"
        aria-label="Plus tard"
        data-testid="update-banner-dismiss-btn"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
